import React from "react";
import "./PrimaryButton.css";

const PrimaryButton = ({ onClick, children, disabled }) => (
  <button
    className="primary-button"
    onClick={onClick}
    disabled={disabled} // Pass the disabled attribute
  >
    {children}
  </button>
);

export default PrimaryButton;
